import type { IDropdownItem } from 'shared/ui'

export enum IntegrationSyncType {
  oneWay = 'oneWay',
  twoWay = 'twoWay',
}

export const GET_SYNC_TYPE_DICT = (name: string) => ({
  [IntegrationSyncType.oneWay]: `Sync to Salesmsg: ${name} -> Salesmsg`,
  [IntegrationSyncType.twoWay]: 'Two-way sync',
})

export const GET_SYNC_TYPE_OPTIONS = (name: string): IDropdownItem[] => {
  const dict = GET_SYNC_TYPE_DICT(name)
  return [
    { id: IntegrationSyncType.oneWay, label: dict[IntegrationSyncType.oneWay] },
    { id: IntegrationSyncType.twoWay, label: dict[IntegrationSyncType.twoWay] },
  ]
}

export const getPropertySync = (field: string, integrationName: string) => {
  return {
    title: 'Contact property sync',
    label: `When enabled, any updates made to contact details in Salesmsg will automatically update the matching contact in ${integrationName}.`,
    field,
  }
}

export const getIntegrationContactCreation = (field: string, integrationName: string) => {
  return {
    title: `${integrationName} contact creation`,
    label: `When enabled, if a contact does not exist in Salesmsg, ${integrationName} will create it when a new contact is added to ${integrationName}`,
    field,
  }
}

export const getContactCreation = (field: string, integrationName: string) => {
  return {
    title: 'Contact creation',
    label: `When enabled, if a contact does not exist in ${integrationName}, Salesmsg will create it when a new contact is added in Salesmsg.`,
    field,
  }
}

export const getIntegrationContactSync = (field: string, integrationName: string) => {
  return {
    title: `${integrationName} contact sync`,
    label: `When enabled, any updates made to contact details in ${integrationName} will automatically update the matching contact in Salesmsg.`,
    field,
  }
}

export const getContactOwnershipSync = (integrationName: string) => {
  return {
    title: 'Contact ownership sync',
    label: `Update the contact owner in ${integrationName} if the contact owner is updated on Salesmsg.`,
    field: 'update_owner',
  }
}
